import http from '@/utils/http'
import service from '@/http/service'

export default {
  orderUrl: `${service.pay}/order`,
  wxUrl: `${service.pay}/wxpay`, // 微信支付
  aliUrl: `${service.pay}/alipay`, // 支付宝
  paymentUrl: `${service.pay}/payment`, // 统一支付
  proUrl: `${service.pay}/product`, // 会员商品
  proCateUrl: `${service.pay}/productCategory`,
  submitOrder(id) {
    return http.post(`${this.orderUrl}/submit?categoryId=${id}`)
  },
  // 前台查询所有商品
  getProductList(params) {
    return http.get(`${this.proUrl}/ownList`, params)
  },
  // 前台查询商品类型
  getProductCategoryList(params) {
    return http.get(`${this.proCateUrl}/ownList`, params)
  },
  // 获取微信二维码
  getWxQrCode(data) {
    return http.post(`${this.wxUrl}/getQRCode`, data)
  },
  getPayQrCode(data) {
    return http.post(`${this.paymentUrl}/pay`, data)
  }
}
